import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './components/public/signin/signin.component';
import { SignoutComponent } from './components/public/signout/signout.component';
import { CustomerComponent } from './components/customer.component';
import { ShiftsComponent } from './components/shifts/shifts.component';
import { MessagesComponent } from './components/messages/messages.component';
import { PasswordComponent } from './components/password/password.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { ForgotPaswordComponent } from './components/public/forgot-pasword/forgot-pasword.component';
import { SettingsComponent } from './components/settings/settings.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { PublicComponent } from './components/public/public.component';
//import { OrderComponent } from './components/public/order.old/order.component';
import { AboutComponent } from './components/public/about/about.component';
import { PrivacyComponent } from './components/public/privacy/privacy.component';
import { PartnersComponent } from './components/public/partners/partners.component';
import { PressComponent } from './components/public/press/press.component';
import { TncComponent as TermsAndConditionsComponent } from './components/public/tnc/tnc.component';
import { OrderComponent } from './components/public/order/order.component';
import { CategoriesComponent } from './components/public/order/categories/categories.component';
import { ServicesComponent } from './components/public/order/services/services.component';
import { ScheduleComponent } from './components/public/order/schedule/schedule.component';

const routes: Routes = [
  { path: 'signout', title: $localize `Sign out`, component: SignoutComponent },
  { 
    path: '', 
    title: $localize `Main`, 
    component: PublicComponent,
    children: [
      { 
        path: '', 
        title: $localize `New order`, 
        component: OrderComponent,
        children: [
          { path: '', title: $localize `New order`, component: CategoriesComponent },
          /*{ path: 'services', title: $localize `New order`, component: CategoriesComponent },*/
          { path: 'services/:slug', title: $localize `New order`, component: ServicesComponent },
          { path: 'schedule', title: $localize `New order`, component: ScheduleComponent },
        ]
      },
      { path: 'partners', title: $localize `Partner`, component: OrderComponent },
      { path: 'partners/:referralCode', title: $localize `New order`, component: PartnersComponent },
      //{ path: '', title: $localize `New order`, component: ChatComponent },
      { path: 'about', title: $localize `About`, component: AboutComponent },
      { path: 'signin', title: $localize `Sign in / Sign up`, component: SigninComponent },
      { path: 'forgot-password', title: $localize `Forgot password`, component: ForgotPaswordComponent },
      { path: 'privacy', title: $localize `Privacy policy`, component: PrivacyComponent },
      { path: 'tnc', title: $localize `Terms and conditions`, component: TermsAndConditionsComponent },
      { path: 'press', title: $localize `Press and media`, component: PressComponent },
    ]
  },
  { 
    path: '', 
    component: CustomerComponent,
    children: [
      { 
        path: '', 
        title: $localize `New order`, 
        component: OrderComponent,
        children: [
          { path: 'checkout', title: $localize `Checkout`, component: CheckoutComponent }
        ]
      },
      { path: 'chat', title: $localize `Chat`, component: MessagesComponent },
      { path: 'shifts', title: $localize `View orders`, component: ShiftsComponent },
      { path: 'shifts/:shiftId', title: $localize `View order`, component: ShiftsComponent },
      { path: 'change-password', title: $localize `Change password`, component: PasswordComponent },
      { path: 'payments/:paymentId', title: $localize `Payments`, component: PaymentsComponent },
      { path: 'settings', title: $localize `Account`, component: SettingsComponent },
      /*{ path: 'reports/location', title: $localize `Costs by location`, component: ReportLocationComponent },*/
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
